
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $ea19eca9a39a7854$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"izUj7\",\"index.e8664e5d.js\",\"d7MF4\",\"icon-avatar-boy.32b3091f.png\",\"2LEms\",\"icon-avatar-boy-96.37cad852.png\",\"9WEJS\",\"icon-avatar-girl.6ca2b332.png\",\"dKnIH\",\"icon-avatar-girl-96.f42e3bc6.png\",\"5K1Sg\",\"icon-avatar-alien.d117f306.png\",\"6n4hh\",\"icon-avatar-alien-96.b1724467.png\",\"4zXq6\",\"icon-avatar-anonymous.ce9fb599.png\",\"gPcZA\",\"icon-avatar-anonymous-96.f6a91d26.png\",\"fuxny\",\"icon-avatar-ironman.63947926.png\",\"inbAh\",\"icon-avatar-ironman-96.a8efa8eb.png\",\"9aksb\",\"icon-avatar-snowball.bea1a23a.png\",\"5LoLc\",\"icon-avatar-snowball-96.0b4895b7.png\",\"dQSCv\",\"icon-avatar-walter-white.a3873271.png\",\"8NisI\",\"icon-avatar-walter-white-96.92b48ac9.png\",\"jZgrj\",\"icon-video-play.9a0d96f7.png\",\"3X2hC\",\"icon-video-pause.c7ce11b5.png\",\"ixd7m\",\"game-music.c3cae339.mp3\",\"3CkeR\",\"button-tap-sound.03262d80.mp3\",\"hHdJA\",\"game-start-sound.b8f1f183.mp3\"]"));

const $360df857f4c2c54a$var$FACE_POSITIONS = {
    1: [
        [
            50,
            50
        ]
    ],
    2: [
        [
            25,
            25
        ],
        [
            75,
            75
        ]
    ],
    3: [
        [
            25,
            25
        ],
        [
            50,
            50
        ],
        [
            75,
            75
        ]
    ],
    4: [
        [
            25,
            25
        ],
        [
            75,
            25
        ],
        [
            25,
            75
        ],
        [
            75,
            75
        ]
    ],
    5: [
        [
            25,
            25
        ],
        [
            75,
            25
        ],
        [
            50,
            50
        ],
        [
            25,
            75
        ],
        [
            75,
            75
        ]
    ],
    6: [
        [
            25,
            20
        ],
        [
            25,
            50
        ],
        [
            25,
            80
        ],
        [
            75,
            20
        ],
        [
            75,
            50
        ],
        [
            75,
            80
        ]
    ]
};
// Which cube face should appear on the FRONT for each value
const $360df857f4c2c54a$var$VALUE_TO_FACE = {
    1: 'front',
    2: 'right',
    3: 'top',
    4: 'bottom',
    5: 'left',
    6: 'back'
};
// Rotations that bring a given cube face to the FRONT.
// IMPORTANT: These values are mathematically correct.
const $360df857f4c2c54a$var$FACE_TO_ROTATION = {
    front: 'rotateX(0deg) rotateY(0deg)',
    back: 'rotateX(0deg) rotateY(180deg)',
    right: 'rotateX(0deg) rotateY(-90deg)',
    left: 'rotateX(0deg) rotateY(90deg)',
    top: 'rotateX(-90deg) rotateY(0deg)',
    bottom: 'rotateX(90deg) rotateY(0deg)'
};
const $360df857f4c2c54a$var$FACE_ORDER = [
    'front',
    'back',
    'right',
    'left',
    'top',
    'bottom'
];
function $360df857f4c2c54a$var$randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $360df857f4c2c54a$var$randomDiceValue() {
    return $360df857f4c2c54a$var$randomInt(1, 6);
}
function $360df857f4c2c54a$var$createPip(x, y) {
    const pip = document.createElement('span');
    pip.className = 'pip';
    pip.style.left = `${x}%`;
    pip.style.top = `${y}%`;
    return pip;
}
function $360df857f4c2c54a$var$createFace(name, value) {
    const face = document.createElement('div');
    face.className = `face ${name}`;
    $360df857f4c2c54a$var$FACE_POSITIONS[value].forEach(([x, y])=>{
        face.appendChild($360df857f4c2c54a$var$createPip(x, y));
    });
    return face;
}
function $360df857f4c2c54a$var$buildDice(diceEl) {
    // Mapping preserves standard opposite faces.
    const faceValues = {
        front: 1,
        back: 6,
        right: 2,
        left: 5,
        top: 3,
        bottom: 4
    };
    $360df857f4c2c54a$var$FACE_ORDER.forEach((faceName)=>{
        diceEl.appendChild($360df857f4c2c54a$var$createFace(faceName, faceValues[faceName]));
    });
}
function $360df857f4c2c54a$var$playRollSound(audioEl) {
    if (!audioEl) return;
    audioEl.currentTime = 0;
    audioEl.play().catch(()=>{
    // Autoplay may be blocked until user interaction.
    });
}
function $360df857f4c2c54a$var$setDiceValue(diceEl, value) {
    const faceName = $360df857f4c2c54a$var$VALUE_TO_FACE[value];
    // Add extra full spins for visual polish while preserving final orientation.
    const spinX = $360df857f4c2c54a$var$randomInt(1, 2) * 360;
    const spinY = $360df857f4c2c54a$var$randomInt(1, 2) * 360;
    diceEl.style.transform = `${$360df857f4c2c54a$var$FACE_TO_ROTATION[faceName]} rotateX(${spinX}deg) rotateY(${spinY}deg)`;
}
/**
 * Rolls both dice together.
 *
 * @param {(payload: {die1:number, die2:number, total:number}) => void} callback
 */ function $360df857f4c2c54a$var$rollBothDice(dice1, dice2, audioEl, callback = (payload)=>console.log(payload)) {
    const dice1Value = $360df857f4c2c54a$var$randomDiceValue();
    const dice2Value = $360df857f4c2c54a$var$randomDiceValue();
    $360df857f4c2c54a$var$playRollSound(audioEl);
    [
        dice1,
        dice2
    ].forEach((dice)=>{
        dice.classList.remove('rolling');
        dice.offsetWidth; // restart animation cleanly
        dice.classList.add('rolling');
    });
    // After tumble animation ends, set the exact orientation.
    setTimeout(()=>{
        [
            dice1,
            dice2
        ].forEach((dice)=>{
            dice.classList.remove('rolling');
        });
        $360df857f4c2c54a$var$setDiceValue(dice1, dice1Value);
        $360df857f4c2c54a$var$setDiceValue(dice2, dice2Value);
        const payload = {
            dice1: dice1Value,
            dice2: dice2Value,
            total: dice1Value + dice2Value
        };
        callback(payload);
    }, 950);
}
class $360df857f4c2c54a$var$DiceRoller {
    constructor(name, dice1Sel, dice2Sel, rollBtnSel, rollAudioSel, diceRollEvent){
        this.name = name;
        this.diceRollEvent = diceRollEvent;
        this.rollBtnId = rollBtnSel;
        this.dice1 = document.getElementById(dice1Sel);
        this.dice2 = document.getElementById(dice2Sel);
        this.rollAudio = document.getElementById(rollAudioSel);
        // Create ONE stable bound handler
        this._boundHandleRollBtnClick = this.handleRollBtnClick.bind(this);
        this.rollBtn = null;
    }
    buildDice(diceEl) {
        $360df857f4c2c54a$var$buildDice(diceEl);
    }
    setDiceValue(diceEl) {
        $360df857f4c2c54a$var$setDiceValue(diceEl, 1);
    }
    handleRollBtnClick() {
        this.rollBtn.disabled = true;
        $360df857f4c2c54a$var$rollBothDice(this.dice1, this.dice2, this.rollAudio, ({ dice1: dice1, dice2: dice2, total: total })=>{
            this.rollBtn.disabled = false;
            console.log(`${this.name}: ${dice1}, ${dice2}, Total: ${total}`);
            document.dispatchEvent(new CustomEvent(this.diceRollEvent, {
                detail: {
                    dice1: dice1,
                    dice2: dice2,
                    total: total
                }
            }));
        });
    }
    attachRollBtn() {
        this.rollBtn = document.getElementById(this.rollBtnId);
        if (!this.rollBtn) return;
        this.rollBtn.addEventListener('click', this._boundHandleRollBtnClick, false);
    }
    detachRollBtn() {
        if (!this.rollBtn) return;
        this.rollBtn.removeEventListener('click', this._boundHandleRollBtnClick, false);
    }
    destroy() {
        // Remove event listener first
        this.detachRollBtn();
        // Clear DOM references
        if (this.dice1) {
            this.dice1.innerHTML = '';
            this.dice1 = null;
        }
        if (this.dice2) {
            this.dice2.innerHTML = '';
            this.dice2 = null;
        }
        this.rollBtn = null;
        this.rollAudio = null;
        this._boundHandleRollBtnClick = null;
    }
}
var $360df857f4c2c54a$export$2e2bcd8739ae039 = $360df857f4c2c54a$var$DiceRoller;


const $3940de47cfa7314f$var$BLUE_COLOR = 'blue';
const $3940de47cfa7314f$var$RED_COLOR = 'red';
const $3940de47cfa7314f$var$GREEN_COLOR = 'green';
const $3940de47cfa7314f$var$YELLOW_COLOR = 'yellow';
const $3940de47cfa7314f$export$c07180e0eb2fbe84 = [
    $3940de47cfa7314f$var$BLUE_COLOR,
    $3940de47cfa7314f$var$RED_COLOR,
    $3940de47cfa7314f$var$GREEN_COLOR,
    $3940de47cfa7314f$var$YELLOW_COLOR
];
const $3940de47cfa7314f$export$67824cee260208a2 = {
    [$3940de47cfa7314f$var$RED_COLOR]: '#EA1D23',
    [$3940de47cfa7314f$var$GREEN_COLOR]: '#00A347',
    [$3940de47cfa7314f$var$BLUE_COLOR]: '#29ADFF',
    [$3940de47cfa7314f$var$YELLOW_COLOR]: '#DABC0F'
};
const $3940de47cfa7314f$export$39493557c84cfd54 = window.innerWidth <= 992;
let $3940de47cfa7314f$export$de8e369147bf54e3 = {
    hasGameStarted: false,
    activeTurn: 'user',
    tokenOpenArr: [
        1,
        6
    ],
    tokenEligibleArr: [],
    playerTurns: 0,
    userDice: {
        first: null,
        second: null
    },
    computerDice: {
        first: null,
        second: null
    },
    userTokens: {},
    computerTokens: {},
    winner: null
};
const $3940de47cfa7314f$export$c7cf9db58a387a28 = '_LH_D_';
const $3940de47cfa7314f$export$159f0a52d65c72e1 = 'user:dice:rolled';
const $3940de47cfa7314f$export$aab74dc964543f9e = 'computer:dice:rolled';
const $3940de47cfa7314f$export$e3962ae0d04ddee0 = 'user:turn:active';
const $3940de47cfa7314f$export$4961220119009338 = 'computer:turn:active';
const $3940de47cfa7314f$export$17cd192a8c1bab9f = [
    {
        left: '300px',
        top: '650px',
        isSafe: true
    },
    {
        left: '300px',
        top: '600px'
    },
    {
        left: '300px',
        top: '550px'
    },
    {
        left: '300px',
        top: '500px'
    },
    {
        left: '300px',
        top: '450px'
    },
    {
        left: '250px',
        top: '400px'
    },
    {
        left: '200px',
        top: '400px'
    },
    {
        left: '150px',
        top: '400px'
    },
    {
        left: '100px',
        top: '400px',
        isSafe: true
    },
    {
        left: '50px',
        top: '400px'
    },
    {
        left: '0px',
        top: '400px'
    },
    {
        left: '0px',
        top: '350px'
    },
    {
        left: '0px',
        top: '300px'
    },
    {
        left: '50px',
        top: '300px',
        isSafe: true
    },
    {
        left: '100px',
        top: '300px'
    },
    {
        left: '150px',
        top: '300px'
    },
    {
        left: '200px',
        top: '300px'
    },
    {
        left: '250px',
        top: '300px'
    },
    {
        left: '300px',
        top: '250px'
    },
    {
        left: '300px',
        top: '200px'
    },
    {
        left: '300px',
        top: '150px'
    },
    {
        left: '300px',
        top: '100px'
    },
    {
        left: '300px',
        top: '50px'
    },
    {
        left: '300px',
        top: '0px'
    },
    {
        left: '350px',
        top: '0px'
    },
    {
        left: '400px',
        top: '0px'
    },
    {
        left: '400px',
        top: '50px',
        isSafe: true
    },
    {
        left: '400px',
        top: '100px'
    },
    {
        left: '400px',
        top: '150px'
    },
    {
        left: '400px',
        top: '200px'
    },
    {
        left: '400px',
        top: '250px'
    },
    {
        left: '450px',
        top: '300px'
    },
    {
        left: '500px',
        top: '300px'
    },
    {
        left: '550px',
        top: '300px'
    },
    {
        left: '600px',
        top: '300px',
        isSafe: true
    },
    {
        left: '650px',
        top: '300px'
    },
    {
        left: '700px',
        top: '300px'
    },
    {
        left: '700px',
        top: '350px'
    },
    {
        left: '700px',
        top: '400px'
    },
    {
        left: '650px',
        top: '400px',
        isSafe: true
    },
    {
        left: '600px',
        top: '400px'
    },
    {
        left: '550px',
        top: '400px'
    },
    {
        left: '500px',
        top: '400px'
    },
    {
        left: '450px',
        top: '400px'
    },
    {
        left: '400px',
        top: '450px'
    },
    {
        left: '400px',
        top: '500px'
    },
    {
        left: '400px',
        top: '550px'
    },
    {
        left: '400px',
        top: '600px',
        isSafe: true
    },
    {
        left: '400px',
        top: '650px'
    },
    {
        left: '400px',
        top: '700px'
    },
    {
        left: '350px',
        top: '700px'
    },
    {
        left: '350px',
        top: '650px',
        isSafe: true
    },
    {
        left: '350px',
        top: '600px',
        isSafe: true
    },
    {
        left: '350px',
        top: '550px',
        isSafe: true
    },
    {
        left: '350px',
        top: '500px',
        isSafe: true
    },
    {
        left: '350px',
        top: '450px',
        isSafe: true
    },
    {
        left: '350px',
        top: '390px',
        isSafe: true
    }
];
const $3940de47cfa7314f$export$5f0081b94ef4f18a = [
    {
        left: '144px',
        top: '312px',
        isSafe: true
    },
    {
        left: '144px',
        top: '288px'
    },
    {
        left: '144px',
        top: '264px'
    },
    {
        left: '144px',
        top: '240px'
    },
    {
        left: '144px',
        top: '216px'
    },
    {
        left: '120px',
        top: '192px'
    },
    {
        left: '96px',
        top: '192px'
    },
    {
        left: '72px',
        top: '192px'
    },
    {
        left: '48px',
        top: '192px',
        isSafe: true
    },
    {
        left: '24px',
        top: '192px'
    },
    {
        left: '0px',
        top: '192px'
    },
    {
        left: '0px',
        top: '168px'
    },
    {
        left: '0px',
        top: '144px'
    },
    {
        left: '24px',
        top: '144px',
        isSafe: true
    },
    {
        left: '48px',
        top: '144px'
    },
    {
        left: '72px',
        top: '144px'
    },
    {
        left: '96px',
        top: '144px'
    },
    {
        left: '120px',
        top: '144px'
    },
    {
        left: '144px',
        top: '120px'
    },
    {
        left: '144px',
        top: '96px'
    },
    {
        left: '144px',
        top: '72px'
    },
    {
        left: '144px',
        top: '48px',
        isSafe: true
    },
    {
        left: '144px',
        top: '24px'
    },
    {
        left: '144px',
        top: '0px'
    },
    {
        left: '168px',
        top: '0px'
    },
    {
        left: '192px',
        top: '0px'
    },
    {
        left: '192px',
        top: '24px',
        isSafe: true
    },
    {
        left: '192px',
        top: '48px'
    },
    {
        left: '192px',
        top: '72px'
    },
    {
        left: '192px',
        top: '96px'
    },
    {
        left: '192px',
        top: '120px'
    },
    {
        left: '216px',
        top: '144px'
    },
    {
        left: '240px',
        top: '144px'
    },
    {
        left: '264px',
        top: '144px'
    },
    {
        left: '288px',
        top: '144px',
        isSafe: true
    },
    {
        left: '312px',
        top: '144px'
    },
    {
        left: '336px',
        top: '144px'
    },
    {
        left: '336px',
        top: '168px'
    },
    {
        left: '336px',
        top: '192px'
    },
    {
        left: '312px',
        top: '192px',
        isSafe: true
    },
    {
        left: '288px',
        top: '192px'
    },
    {
        left: '264px',
        top: '192px'
    },
    {
        left: '240px',
        top: '192px'
    },
    {
        left: '216px',
        top: '192px'
    },
    {
        left: '192px',
        top: '216px'
    },
    {
        left: '192px',
        top: '240px'
    },
    {
        left: '192px',
        top: '264px'
    },
    {
        left: '192px',
        top: '288px',
        isSafe: true
    },
    {
        left: '192px',
        top: '312px'
    },
    {
        left: '192px',
        top: '336px'
    },
    {
        left: '168px',
        top: '336px'
    },
    {
        left: '168px',
        top: '312px',
        isSafe: true
    },
    {
        left: '168px',
        top: '288px',
        isSafe: true
    },
    {
        left: '168px',
        top: '264px',
        isSafe: true
    },
    {
        left: '168px',
        top: '240px',
        isSafe: true
    },
    {
        left: '168px',
        top: '216px',
        isSafe: true
    },
    {
        left: '168px',
        top: '187px',
        isSafe: true
    }
];
const $3940de47cfa7314f$export$a603f1620086eaac = [
    {
        left: '400px',
        top: '50px',
        isSafe: true
    },
    {
        left: '400px',
        top: '100px'
    },
    {
        left: '400px',
        top: '150px'
    },
    {
        left: '400px',
        top: '200px'
    },
    {
        left: '400px',
        top: '250px'
    },
    {
        left: '450px',
        top: '300px'
    },
    {
        left: '500px',
        top: '300px'
    },
    {
        left: '550px',
        top: '300px'
    },
    {
        left: '600px',
        top: '300px',
        isSafe: true
    },
    {
        left: '650px',
        top: '300px'
    },
    {
        left: '700px',
        top: '300px'
    },
    {
        left: '700px',
        top: '350px'
    },
    {
        left: '700px',
        top: '400px'
    },
    {
        left: '650px',
        top: '400px',
        isSafe: true
    },
    {
        left: '600px',
        top: '400px'
    },
    {
        left: '550px',
        top: '400px'
    },
    {
        left: '500px',
        top: '400px'
    },
    {
        left: '450px',
        top: '400px'
    },
    {
        left: '400px',
        top: '450px'
    },
    {
        left: '400px',
        top: '500px'
    },
    {
        left: '400px',
        top: '550px'
    },
    {
        left: '400px',
        top: '600px',
        isSafe: true
    },
    {
        left: '400px',
        top: '650px'
    },
    {
        left: '400px',
        top: '700px'
    },
    {
        left: '350px',
        top: '700px'
    },
    {
        left: '300px',
        top: '700px'
    },
    {
        left: '300px',
        top: '650px',
        isSafe: true
    },
    {
        left: '300px',
        top: '600px'
    },
    {
        left: '300px',
        top: '550px'
    },
    {
        left: '300px',
        top: '500px'
    },
    {
        left: '300px',
        top: '450px'
    },
    {
        left: '250px',
        top: '400px'
    },
    {
        left: '200px',
        top: '400px'
    },
    {
        left: '150px',
        top: '400px'
    },
    {
        left: '100px',
        top: '400px',
        isSafe: true
    },
    {
        left: '50px',
        top: '400px'
    },
    {
        left: '0px',
        top: '400px'
    },
    {
        left: '0px',
        top: '350px'
    },
    {
        left: '0px',
        top: '300px'
    },
    {
        left: '50px',
        top: '300px',
        isSafe: true
    },
    {
        left: '100px',
        top: '300px'
    },
    {
        left: '150px',
        top: '300px'
    },
    {
        left: '200px',
        top: '300px'
    },
    {
        left: '250px',
        top: '300px'
    },
    {
        left: '300px',
        top: '250px'
    },
    {
        left: '300px',
        top: '200px'
    },
    {
        left: '300px',
        top: '150px'
    },
    {
        left: '300px',
        top: '100px'
    },
    {
        left: '300px',
        top: '50px'
    },
    {
        left: '300px',
        top: '0px'
    },
    {
        left: '350px',
        top: '0px'
    },
    {
        left: '350px',
        top: '50px',
        isSafe: true
    },
    {
        left: '350px',
        top: '100px',
        isSafe: true
    },
    {
        left: '350px',
        top: '150px',
        isSafe: true
    },
    {
        left: '350px',
        top: '200px',
        isSafe: true
    },
    {
        left: '350px',
        top: '250px',
        isSafe: true
    },
    {
        left: '350px',
        top: '300px',
        isSafe: true
    }
];
const $3940de47cfa7314f$export$329cf0911c3b69bf = [
    {
        left: '192px',
        top: '24px',
        isSafe: true
    },
    {
        left: '192px',
        top: '48px'
    },
    {
        left: '192px',
        top: '72px'
    },
    {
        left: '192px',
        top: '96px'
    },
    {
        left: '192px',
        top: '120px'
    },
    {
        left: '216px',
        top: '144px'
    },
    {
        left: '240px',
        top: '144px'
    },
    {
        left: '264px',
        top: '144px'
    },
    {
        left: '288px',
        top: '144px',
        isSafe: true
    },
    {
        left: '312px',
        top: '144px'
    },
    {
        left: '336px',
        top: '144px'
    },
    {
        left: '336px',
        top: '168px'
    },
    {
        left: '336px',
        top: '192px'
    },
    {
        left: '312px',
        top: '192px',
        isSafe: true
    },
    {
        left: '288px',
        top: '192px'
    },
    {
        left: '264px',
        top: '192px'
    },
    {
        left: '240px',
        top: '192px'
    },
    {
        left: '216px',
        top: '192px'
    },
    {
        left: '192px',
        top: '216px'
    },
    {
        left: '192px',
        top: '240px'
    },
    {
        left: '192px',
        top: '264px'
    },
    {
        left: '192px',
        top: '288px',
        isSafe: true
    },
    {
        left: '192px',
        top: '312px'
    },
    {
        left: '192px',
        top: '336px'
    },
    {
        left: '168px',
        top: '336px'
    },
    {
        left: '144px',
        top: '336px'
    },
    {
        left: '144px',
        top: '312px',
        isSafe: true
    },
    {
        left: '144px',
        top: '288px'
    },
    {
        left: '144px',
        top: '264px'
    },
    {
        left: '144px',
        top: '240px'
    },
    {
        left: '144px',
        top: '216px'
    },
    {
        left: '120px',
        top: '192px'
    },
    {
        left: '96px',
        top: '192px'
    },
    {
        left: '72px',
        top: '192px'
    },
    {
        left: '48px',
        top: '192px',
        isSafe: true
    },
    {
        left: '24px',
        top: '192px'
    },
    {
        left: '0px',
        top: '192px'
    },
    {
        left: '0px',
        top: '168px'
    },
    {
        left: '0px',
        top: '144px'
    },
    {
        left: '24px',
        top: '144px',
        isSafe: true
    },
    {
        left: '48px',
        top: '144px'
    },
    {
        left: '72px',
        top: '144px'
    },
    {
        left: '96px',
        top: '144px'
    },
    {
        left: '120px',
        top: '144px'
    },
    {
        left: '144px',
        top: '120px'
    },
    {
        left: '144px',
        top: '96px'
    },
    {
        left: '144px',
        top: '72px'
    },
    {
        left: '144px',
        top: '48px',
        isSafe: true
    },
    {
        left: '144px',
        top: '24px'
    },
    {
        left: '144px',
        top: '0px'
    },
    {
        left: '168px',
        top: '0px'
    },
    {
        left: '168px',
        top: '24px',
        isSafe: true
    },
    {
        left: '168px',
        top: '48px',
        isSafe: true
    },
    {
        left: '168px',
        top: '72px',
        isSafe: true
    },
    {
        left: '168px',
        top: '96px',
        isSafe: true
    },
    {
        left: '168px',
        top: '120px',
        isSafe: true
    },
    {
        left: '168px',
        top: '144px',
        isSafe: true
    }
];


/** DOM element Refs **/ const $1168ec28d852752a$export$d00693a4067fd789 = (sel)=>document.querySelector(sel);
const $1168ec28d852752a$export$db728655bca7f82b = (sel)=>document.querySelectorAll(sel);
const $1168ec28d852752a$export$1bb2862a071337fd = (id)=>document.getElementById(id);
/** Onboarding Splashscreen **/ const $1168ec28d852752a$export$3ce7eb6bf6aeba9b = $1168ec28d852752a$export$d00693a4067fd789('.js-splashScreen');
const $1168ec28d852752a$export$e3883f6433e2084 = $1168ec28d852752a$export$1bb2862a071337fd('vs-computer');
const $1168ec28d852752a$export$cd1a97c55c4a1527 = $1168ec28d852752a$export$d00693a4067fd789('.js-hero-buttons');
const $1168ec28d852752a$export$515ff3308e40a8b1 = $1168ec28d852752a$export$d00693a4067fd789('.js-icon-bg-play');
/** Onboarding screen: Color Selection **/ const $1168ec28d852752a$export$e40889aa17b92c99 = $1168ec28d852752a$export$db728655bca7f82b('.js-color-selection');
const $1168ec28d852752a$export$6bf51dee7fb7b55a = $1168ec28d852752a$export$d00693a4067fd789('.js-cs-wrapper');
const $1168ec28d852752a$export$d452ebc8b446b4ac = $1168ec28d852752a$export$d00693a4067fd789('.js-back-btn');
const $1168ec28d852752a$export$beb2893780e62d5f = $1168ec28d852752a$export$d00693a4067fd789('.js-play-btn');
/** Onboarding screen: Personal Information **/ const $1168ec28d852752a$export$a2a84eafc2713335 = $1168ec28d852752a$export$d00693a4067fd789('.js-pi-wrapper');
const $1168ec28d852752a$export$d27b0802ab3cc977 = $1168ec28d852752a$export$d00693a4067fd789('.js-pi-name-input');
const $1168ec28d852752a$export$c548831468cc80db = $1168ec28d852752a$export$db728655bca7f82b('.js-avatar');
const $1168ec28d852752a$export$50020fa44678e7c8 = $1168ec28d852752a$export$d00693a4067fd789('.js-pi-back-btn');
const $1168ec28d852752a$export$f70504349406a407 = $1168ec28d852752a$export$d00693a4067fd789('.js-pi-next');
/** Main App screen **/ const $1168ec28d852752a$export$5a999186c9b43a0c = $1168ec28d852752a$export$d00693a4067fd789('.js-app-back-btn');
const $1168ec28d852752a$export$1f183a908848c907 = $1168ec28d852752a$export$d00693a4067fd789('.js-app');
const $1168ec28d852752a$export$70fcad33caef45a9 = $1168ec28d852752a$export$d00693a4067fd789('.js-avatar-user');
const $1168ec28d852752a$export$5e9b7b9ab82179a7 = $1168ec28d852752a$export$d00693a4067fd789('.js-avatar-computer');
const $1168ec28d852752a$export$b80866afb1e34266 = $1168ec28d852752a$export$d00693a4067fd789('.js-avatar-user-img');
const $1168ec28d852752a$export$f041ceeccee253fc = $1168ec28d852752a$export$d00693a4067fd789('.js-avatar-user-text');
const $1168ec28d852752a$export$3afb6fec7d6afc7c = $1168ec28d852752a$export$d00693a4067fd789('.js-avatar-computer-img');
const $1168ec28d852752a$export$7302c976fb091b27 = $1168ec28d852752a$export$d00693a4067fd789('.js-avatar-computer-text');
// User Dice Container
const $1168ec28d852752a$export$747ca200babe9292 = $1168ec28d852752a$export$d00693a4067fd789('#dice-cover-user-1');
const $1168ec28d852752a$export$a37d94e9af1a9115 = $1168ec28d852752a$export$d00693a4067fd789('#dice-cover-user-2');
// Computer Dice Container
const $1168ec28d852752a$export$e1124a4189ecaf6e = $1168ec28d852752a$export$d00693a4067fd789('#dice-cover-computer-1');
const $1168ec28d852752a$export$ae90a12dc449330f = $1168ec28d852752a$export$d00693a4067fd789('#dice-cover-computer-2');
// User Dice Button
const $1168ec28d852752a$export$5b5a59babade6caa = $1168ec28d852752a$export$d00693a4067fd789('.js-user-dice-btn');
// Computer Dice Button
const $1168ec28d852752a$export$a7e61876d5641618 = $1168ec28d852752a$export$d00693a4067fd789('.js-computer-dice-btn');
// User Dice Arrow
const $1168ec28d852752a$export$e910906a19a619c7 = $1168ec28d852752a$export$5b5a59babade6caa.querySelector('.js-user-arrow-ind');
// User Dice Arrow indicators
const $1168ec28d852752a$export$5c2a73161bb2780a = $1168ec28d852752a$export$747ca200babe9292.querySelector('.js-arrow-ind');
const $1168ec28d852752a$export$49356edcc2c3205c = $1168ec28d852752a$export$a37d94e9af1a9115.querySelector('.js-arrow-ind');


/** Set Global variables **/ const $e73bf42412feb220$var$ls = window.localStorage;
/** Onboarding: Selected token color **/ let $e73bf42412feb220$var$_selectedColor = '';
let $e73bf42412feb220$var$_computerColor = '';
/** Onboarding: User name and avatar info **/ let $e73bf42412feb220$var$_personalData = $e73bf42412feb220$var$getStorage((0, $3940de47cfa7314f$export$c7cf9db58a387a28));
let $e73bf42412feb220$var$_userName = $e73bf42412feb220$var$_personalData?.userName || '';
let $e73bf42412feb220$var$_userAvatar = $e73bf42412feb220$var$_personalData?.userAvatar || '';
let $e73bf42412feb220$var$_userAvatarURL = $e73bf42412feb220$var$_personalData?.userAvatarURL || '';
let $e73bf42412feb220$var$_isBgPlayStarted = false;
/** Main Gameplay **/ let $e73bf42412feb220$var$gs = structuredClone((0, $3940de47cfa7314f$export$de8e369147bf54e3));
let $e73bf42412feb220$var$_userDice = null;
let $e73bf42412feb220$var$_computerDice = null;
var $6ef1a69af8c11261$exports = {};
$6ef1a69af8c11261$exports = new URL("icon-avatar-boy.32b3091f.png", import.meta.url).toString();


var $0b0657532591f58b$exports = {};
$0b0657532591f58b$exports = new URL("icon-avatar-boy-96.37cad852.png", import.meta.url).toString();


var $f059fea3fa40efb2$exports = {};
$f059fea3fa40efb2$exports = new URL("icon-avatar-girl.6ca2b332.png", import.meta.url).toString();


var $0f4edbf01f961033$exports = {};
$0f4edbf01f961033$exports = new URL("icon-avatar-girl-96.f42e3bc6.png", import.meta.url).toString();


/** User & Computer avatars **/ const $e73bf42412feb220$var$userAvatars = [
    {
        name: 'Boy',
        gender: 'male',
        url_48: new URL($6ef1a69af8c11261$exports).pathname,
        url_96: new URL($0b0657532591f58b$exports).pathname
    },
    {
        name: 'Girl',
        gender: 'female',
        url_48: new URL($f059fea3fa40efb2$exports).pathname,
        url_96: new URL($0f4edbf01f961033$exports).pathname
    }
];
var $cb9e3868cd90f207$exports = {};
$cb9e3868cd90f207$exports = new URL("icon-avatar-alien.d117f306.png", import.meta.url).toString();


var $7772541053673b12$exports = {};
$7772541053673b12$exports = new URL("icon-avatar-alien-96.b1724467.png", import.meta.url).toString();


var $6fdda703dd073a73$exports = {};
$6fdda703dd073a73$exports = new URL("icon-avatar-anonymous.ce9fb599.png", import.meta.url).toString();


var $c364398f9d79e13d$exports = {};
$c364398f9d79e13d$exports = new URL("icon-avatar-anonymous-96.f6a91d26.png", import.meta.url).toString();


var $c547b1463e0d4aeb$exports = {};
$c547b1463e0d4aeb$exports = new URL("icon-avatar-ironman.63947926.png", import.meta.url).toString();


var $0d716f044d26dbf9$exports = {};
$0d716f044d26dbf9$exports = new URL("icon-avatar-ironman-96.a8efa8eb.png", import.meta.url).toString();


var $3cc3e80c84feff32$exports = {};
$3cc3e80c84feff32$exports = new URL("icon-avatar-snowball.bea1a23a.png", import.meta.url).toString();


var $9c7e03f70a666334$exports = {};
$9c7e03f70a666334$exports = new URL("icon-avatar-snowball-96.0b4895b7.png", import.meta.url).toString();


var $1773a5a52fb1c85d$exports = {};
$1773a5a52fb1c85d$exports = new URL("icon-avatar-walter-white.a3873271.png", import.meta.url).toString();


var $1c727e1552a1cd3d$exports = {};
$1c727e1552a1cd3d$exports = new URL("icon-avatar-walter-white-96.92b48ac9.png", import.meta.url).toString();


const $e73bf42412feb220$var$computerAvatars = [
    {
        name: 'Alien',
        url_48: new URL($cb9e3868cd90f207$exports).pathname,
        url_96: new URL($7772541053673b12$exports).pathname
    },
    {
        name: 'Anonymous',
        url_48: new URL($6fdda703dd073a73$exports).pathname,
        url_96: new URL($c364398f9d79e13d$exports).pathname
    },
    {
        name: 'Iron Man',
        url_48: new URL($c547b1463e0d4aeb$exports).pathname,
        url_96: new URL($0d716f044d26dbf9$exports).pathname
    },
    {
        name: 'Snowball',
        url_48: new URL($3cc3e80c84feff32$exports).pathname,
        url_96: new URL($9c7e03f70a666334$exports).pathname
    },
    {
        name: 'Walter White',
        url_48: new URL($1773a5a52fb1c85d$exports).pathname,
        url_96: new URL($1c727e1552a1cd3d$exports).pathname
    }
];
var $8cb1728fdca09ce8$exports = {};
$8cb1728fdca09ce8$exports = new URL("icon-video-play.9a0d96f7.png", import.meta.url).toString();


/** Image and Audio Refs **/ const $e73bf42412feb220$var$bgPlayIconPath = new URL($8cb1728fdca09ce8$exports);
var $7ae368777e9520f8$exports = {};
$7ae368777e9520f8$exports = new URL("icon-video-pause.c7ce11b5.png", import.meta.url).toString();


const $e73bf42412feb220$var$bgPauseIconPath = new URL($7ae368777e9520f8$exports);
var $9eb1cbde262db9d8$exports = {};
$9eb1cbde262db9d8$exports = new URL("game-music.c3cae339.mp3", import.meta.url).toString();


const $e73bf42412feb220$var$gameMusicPath = new URL($9eb1cbde262db9d8$exports);
var $fc97dce9447959ad$exports = {};
$fc97dce9447959ad$exports = new URL("button-tap-sound.03262d80.mp3", import.meta.url).toString();


const $e73bf42412feb220$var$interactionMusicPath = new URL($fc97dce9447959ad$exports);
var $60cf9cbf688894e0$exports = {};
$60cf9cbf688894e0$exports = new URL("game-start-sound.b8f1f183.mp3", import.meta.url).toString();


const $e73bf42412feb220$var$gameStartMusicPath = new URL($60cf9cbf688894e0$exports);
const $e73bf42412feb220$var$gameAudio = new Audio($e73bf42412feb220$var$gameMusicPath);
const $e73bf42412feb220$var$interactionAudio = new Audio($e73bf42412feb220$var$interactionMusicPath);
const $e73bf42412feb220$var$gameStartAudio = new Audio($e73bf42412feb220$var$gameStartMusicPath);
/** Miscellaneous functions **/ function $e73bf42412feb220$var$getStorage(key) {
    return JSON.parse($e73bf42412feb220$var$ls.getItem(key));
}
function $e73bf42412feb220$var$setStorage(key, value) {
    $e73bf42412feb220$var$ls.setItem(key, value);
}
function $e73bf42412feb220$var$setUserInfoInStorage(key, _userName, _userAvatar, _userAvatarURL) {
    const data = {
        userName: _userName,
        userAvatar: _userAvatar,
        userAvatarURL: _userAvatarURL
    };
    $e73bf42412feb220$var$setStorage(key, JSON.stringify(data));
}
function $e73bf42412feb220$var$getActiveColors(color) {
    if (color == '') return null;
    color = color.toLowerCase();
    const userColorIdx = (0, $3940de47cfa7314f$export$c07180e0eb2fbe84).indexOf(color);
    // In our game, the computer will appear diagonally to the end user.
    // Thus, we can get computer color index by adding 2 to the user color index.
    let computerColorIdx = userColorIdx + 2 >= (0, $3940de47cfa7314f$export$c07180e0eb2fbe84).length ? userColorIdx - 2 : userColorIdx + 2;
    return [
        color,
        (0, $3940de47cfa7314f$export$c07180e0eb2fbe84)[computerColorIdx]
    ];
}
function $e73bf42412feb220$var$togglePINextVisibility() {
    if ($e73bf42412feb220$var$_userName && $e73bf42412feb220$var$_userAvatar && $e73bf42412feb220$var$_userAvatarURL) {
        $e73bf42412feb220$var$enablePINextBtn();
        return;
    }
    $e73bf42412feb220$var$disablePINextBtn();
}
function $e73bf42412feb220$var$disablePINextBtn() {
    (0, $1168ec28d852752a$export$f70504349406a407).disabled = true;
    (0, $1168ec28d852752a$export$f70504349406a407).classList.remove('ani-bounce');
}
function $e73bf42412feb220$var$enablePINextBtn() {
    (0, $1168ec28d852752a$export$f70504349406a407).disabled = false;
    (0, $1168ec28d852752a$export$f70504349406a407).classList.add('ani-bounce');
}
function $e73bf42412feb220$var$disablePlayBtn() {
    (0, $1168ec28d852752a$export$beb2893780e62d5f).disabled = true;
    (0, $1168ec28d852752a$export$beb2893780e62d5f).classList.remove('ani-bounce');
}
function $e73bf42412feb220$var$enablePlayBtn() {
    (0, $1168ec28d852752a$export$beb2893780e62d5f).disabled = false;
    (0, $1168ec28d852752a$export$beb2893780e62d5f).classList.add('ani-bounce');
}
function $e73bf42412feb220$var$showPulseAnim(el) {
    el.classList.add('ani-pulse');
}
function $e73bf42412feb220$var$hidePulseAnim(el) {
    el.classList.remove('ani-pulse');
}
function $e73bf42412feb220$var$addClassToEl(el, clsName) {
    el.classList.add(clsName);
}
function $e73bf42412feb220$var$removeClassFromEl(el, clsName) {
    el.classList.remove(clsName);
}
/** Populate PI Screen if localstorage data exists **/ function $e73bf42412feb220$var$populatePIScreen() {
    let piData = $e73bf42412feb220$var$_personalData;
    if (!piData?.userName || !piData?.userAvatar || !piData?.userAvatarURL) {
        console.log('No personal data found in storage to populate PI screen.');
        return false;
    }
    (0, $1168ec28d852752a$export$d27b0802ab3cc977).value = piData.userName;
    const avatarEl = (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-avatar[data-avatar="${piData.userAvatar}"]`);
    avatarEl ? avatarEl.classList.add('avatar-active') : console.log('No avatar element found to set active state.');
    $e73bf42412feb220$var$enablePINextBtn();
}
/** Reset UI screens - State and UI **/ function $e73bf42412feb220$var$resetPIScreen() {
    // Reset state
    $e73bf42412feb220$var$_userName = '';
    $e73bf42412feb220$var$_userAvatar = '';
    $e73bf42412feb220$var$_userAvatarURL = '';
    // Reset UI
    (0, $1168ec28d852752a$export$d27b0802ab3cc977).value = '';
    (0, $1168ec28d852752a$export$db728655bca7f82b)('.js-avatar').forEach((node)=>{
        node.classList.remove('avatar-active');
    });
    $e73bf42412feb220$var$disablePINextBtn();
}
function $e73bf42412feb220$var$resetColorSelectScreen() {
    // Reset state
    $e73bf42412feb220$var$disablePlayBtn();
    $e73bf42412feb220$var$_selectedColor = '';
    // Reset all color selection nodes
    (0, $1168ec28d852752a$export$e40889aa17b92c99).forEach((selectionEl)=>selectionEl.dataset['flag'] = '0');
}
/** Event Handlers **/ function $e73bf42412feb220$var$handleSelectionClick(e) {
    const el = e.currentTarget;
    // Toggle checkbox flag
    const toggledFlag = Number(!Number(el.dataset['flag']));
    el.dataset['flag'] = toggledFlag;
    if (toggledFlag) {
        $e73bf42412feb220$var$enablePlayBtn();
        $e73bf42412feb220$var$_selectedColor = el.dataset['color'];
    } else {
        $e73bf42412feb220$var$disablePlayBtn();
        $e73bf42412feb220$var$_selectedColor = '';
    }
    // Reset flags of other color selection nodes
    (0, $1168ec28d852752a$export$e40889aa17b92c99).forEach((selectionEl)=>{
        if (selectionEl.dataset['color'] === $e73bf42412feb220$var$_selectedColor) return;
        selectionEl.dataset['flag'] = '0';
    });
}
function $e73bf42412feb220$var$handleVSComputerClick() {
    (0, $1168ec28d852752a$export$cd1a97c55c4a1527).classList.add('d-none');
    (0, $1168ec28d852752a$export$a2a84eafc2713335).classList.remove('d-none');
}
function $e73bf42412feb220$var$handlePIBackBtnClick() {
    // resetPIScreen();
    // Toggle containers visibility
    (0, $1168ec28d852752a$export$a2a84eafc2713335).classList.add('d-none');
    (0, $1168ec28d852752a$export$cd1a97c55c4a1527).classList.remove('d-none');
}
function $e73bf42412feb220$var$setUserNameInputError() {
    $e73bf42412feb220$var$_userName = '';
    (0, $1168ec28d852752a$export$d27b0802ab3cc977).classList.add('bx-red');
    (0, $1168ec28d852752a$export$d27b0802ab3cc977).focus();
}
function $e73bf42412feb220$var$handlePINextBtnClick() {
    // User name state validation
    if (!$e73bf42412feb220$var$_userName || (0, $1168ec28d852752a$export$d27b0802ab3cc977).value.trim() === '' || $e73bf42412feb220$var$_userName.length < 3 || $e73bf42412feb220$var$_userName.length > 12) {
        alert('Please enter your user name between 3-12 characters.');
        $e73bf42412feb220$var$setUserNameInputError();
        (0, $1168ec28d852752a$export$f70504349406a407).classList.remove('ani-bounce');
        return false;
    }
    (0, $1168ec28d852752a$export$d27b0802ab3cc977).classList.remove('bx-red');
    (0, $1168ec28d852752a$export$a2a84eafc2713335).classList.add('d-none');
    /** Color Selection Screen: Prepare this screen for the end user with a state and UI reset **/ $e73bf42412feb220$var$resetColorSelectScreen();
    (0, $1168ec28d852752a$export$6bf51dee7fb7b55a).classList.remove('d-none');
}
function $e73bf42412feb220$var$handleBackBtnClick() {
    $e73bf42412feb220$var$resetColorSelectScreen();
    (0, $1168ec28d852752a$export$a2a84eafc2713335).classList.remove('d-none');
    (0, $1168ec28d852752a$export$6bf51dee7fb7b55a).classList.add('d-none');
}
function $e73bf42412feb220$var$handlePlayBtnClick() {
    if (!$e73bf42412feb220$var$_selectedColor) return false;
    $e73bf42412feb220$var$initGamePlay();
}
function $e73bf42412feb220$var$handleAppBackBtnClick() {
    const isAppLogout = window.confirm('Do you wish to exit this game?');
    if (!isAppLogout) return false;
    // Reset Game State
    $e73bf42412feb220$var$gs = structuredClone((0, $3940de47cfa7314f$export$de8e369147bf54e3));
    // Reset user dice refs and UI
    $e73bf42412feb220$var$_userDice.destroy();
    $e73bf42412feb220$var$_userDice = null;
    // Reset computer dice refs and UI
    $e73bf42412feb220$var$_computerDice.destroy();
    $e73bf42412feb220$var$_computerDice = null;
    // Hide App screen and show user onboarding screen
    (0, $1168ec28d852752a$export$1f183a908848c907).classList.add('d-none');
    (0, $1168ec28d852752a$export$3ce7eb6bf6aeba9b).classList.remove('d-none');
    // Reset user onboarding
    (0, $1168ec28d852752a$export$6bf51dee7fb7b55a).classList.add('d-none');
    (0, $1168ec28d852752a$export$cd1a97c55c4a1527).classList.remove('d-none');
    // Hide pulse animation from User and Computer avatars
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$70fcad33caef45a9));
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$5e9b7b9ab82179a7));
    // Hide pulse animation for first and second User dice
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$747ca200babe9292));
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$a37d94e9af1a9115));
    // Hide pulse animation for first and second Computer dice
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$e1124a4189ecaf6e));
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$ae90a12dc449330f));
    // Show all color tokens
    (0, $1168ec28d852752a$export$db728655bca7f82b)('.js-token').forEach((node)=>{
        node.classList.remove('d-none', 'token-eligible');
        // Reset every token position
        node.style.left = '';
        node.style.top = '';
        const computerClsName = Array.from(node.classList).find((item)=>item.includes('game-token-computer-'));
        const userClsName = Array.from(node.classList).find((item)=>item.includes('game-token-user-'));
        // Reset current computer tokens
        if (computerClsName) node.classList.remove(computerClsName);
        // Reset current user tokens
        if (userClsName) node.classList.remove(userClsName);
    });
    // Reset onboarding screens
    $e73bf42412feb220$var$resetColorSelectScreen();
    $e73bf42412feb220$var$_computerColor = '';
}
function $e73bf42412feb220$var$handleBgPlayClick(e) {
    const el = e.currentTarget;
    const img = el.querySelector('.icon-bg-play');
    $e73bf42412feb220$var$_isBgPlayStarted = !$e73bf42412feb220$var$_isBgPlayStarted;
    if (!$e73bf42412feb220$var$_isBgPlayStarted) {
        img.src = $e73bf42412feb220$var$bgPlayIconPath;
        $e73bf42412feb220$var$pauseAudio($e73bf42412feb220$var$gameAudio);
        return;
    }
    img.src = $e73bf42412feb220$var$bgPauseIconPath;
    $e73bf42412feb220$var$playAudio($e73bf42412feb220$var$gameAudio, true);
    console.log('background play click:');
}
function $e73bf42412feb220$var$handlePageInteractionClick(e) {
    const excludeClassNames = [
        'game-token-computer-1',
        'game-token-computer-2',
        'game-token-computer-3',
        'game-token-computer-4'
    ];
    const elClassList = e.target.classList;
    const isExcludedClassName = excludeClassNames.reduce((flag, clsName)=>{
        (elClassList.contains(clsName) || e.target.parentNode.classList.contains(clsName)) && (flag = true);
        return flag;
    }, false);
    const isSoundEl = elClassList.contains('js-sound') || e.target.closest('.js-sound');
    if (isExcludedClassName || !isSoundEl) return false;
    $e73bf42412feb220$var$playAudio($e73bf42412feb220$var$interactionAudio);
}
function $e73bf42412feb220$var$handleUserNameInteraction(e) {
    $e73bf42412feb220$var$_userName = e.target.value;
    /** TODO: Implement a debounce function (~ 250 ms) to properly check the PI next button visibility */ $e73bf42412feb220$var$togglePINextVisibility();
}
function $e73bf42412feb220$var$handleUserAvatarClick(e) {
    const el = e.currentTarget;
    // Reset 'avatar-active' classname
    (0, $1168ec28d852752a$export$db728655bca7f82b)('.js-avatar').forEach((node)=>{
        node.classList.remove('avatar-active');
    });
    el.classList.add('avatar-active');
    // Set user avatar
    $e73bf42412feb220$var$_userAvatar = el.dataset['avatar'];
    // Set user avatar URL
    $e73bf42412feb220$var$_userAvatarURL = el.querySelector('img').getAttribute('src');
    $e73bf42412feb220$var$togglePINextVisibility();
}
function $e73bf42412feb220$var$handleUserTokenClick(e) {
    const isUserTurn = $e73bf42412feb220$var$gs.activeTurn === 'user' && $e73bf42412feb220$var$gs.playerTurns && ($e73bf42412feb220$var$gs.userDice.first || $e73bf42412feb220$var$gs.userDice.second);
    if (!isUserTurn) {
        console.log('No user turn left: ', $e73bf42412feb220$var$gs.playerTurns);
        return false;
    }
    const el = e.target;
    const userToken = $e73bf42412feb220$var$getTokenById(el, $e73bf42412feb220$var$gs.userTokens);
    const eligibleToken = $e73bf42412feb220$var$gs.tokenEligibleArr.find((token)=>token.id === userToken.id);
    if (!eligibleToken) {
        console.log('[UserTokenClick]: Current DOM el is not eligible.');
        return false;
    }
    const dice = $e73bf42412feb220$var$gs.userDice.first || $e73bf42412feb220$var$gs.userDice.second;
    const isTokenEligibleToOpen = eligibleToken && $e73bf42412feb220$var$gs.tokenOpenArr.indexOf(dice) > -1 && userToken.index === 0 && userToken.isAtHome && !userToken.isOpen && !userToken.isSafe && !userToken.isAtFort;
    const pathIndex = isTokenEligibleToOpen ? 0 : userToken.index + dice;
    const currentState = (0, $3940de47cfa7314f$export$39493557c84cfd54) ? (0, $3940de47cfa7314f$export$5f0081b94ef4f18a)[pathIndex] : (0, $3940de47cfa7314f$export$17cd192a8c1bab9f)[pathIndex];
    if (isTokenEligibleToOpen) {
        userToken.isOpen = true;
        userToken.isAtHome = false;
    }
    // Update user index to new path location
    userToken.index = pathIndex;
    // Move the user token to new path location
    userToken.el.style.left = currentState.left;
    userToken.el.style.top = currentState.top;
    // Decrement player turn by one
    $e73bf42412feb220$var$gs.playerTurns -= 1;
    // Reset eligible token className from all tokens
    $e73bf42412feb220$var$gs.tokenEligibleArr.forEach((token)=>{
        token.el.classList.remove('token-eligible');
    });
    if ($e73bf42412feb220$var$gs.userDice.first) {
        $e73bf42412feb220$var$gs.userDice.first = null;
        // Set Eligible tokens for Dice2
        $e73bf42412feb220$var$gs.tokenEligibleArr = $e73bf42412feb220$var$getEligibleTokens($e73bf42412feb220$var$gs.userDice.second, $e73bf42412feb220$var$gs.userTokens);
        // Set eligible tokens active
        $e73bf42412feb220$var$gs.tokenEligibleArr.forEach((token)=>{
            token.el.classList.add('token-eligible');
        });
        // Hide pulse animation for first user dice
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$747ca200babe9292));
        // Show pulse animation for second user dice
        $e73bf42412feb220$var$showPulseAnim((0, $1168ec28d852752a$export$a37d94e9af1a9115));
        // Hide arrow indicator from the first user dice
        $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$5c2a73161bb2780a), 'd-none');
        // Show arrow indicator on the "second" user dice
        $e73bf42412feb220$var$removeClassFromEl((0, $1168ec28d852752a$export$49356edcc2c3205c), 'd-none');
    } else if ($e73bf42412feb220$var$gs.userDice.second) {
        $e73bf42412feb220$var$gs.userDice.second = null;
        $e73bf42412feb220$var$gs.tokenEligibleArr = [];
        // Hide pulse animations for first and second user dice
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$747ca200babe9292));
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$a37d94e9af1a9115));
        // Hide arrow indicators from first and second user dice
        $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$5c2a73161bb2780a), 'd-none');
        $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$49356edcc2c3205c), 'd-none');
        $e73bf42412feb220$var$dispatchComputerTurnEvent();
    }
    console.log('[UserTokenClick] Current game state: ', $e73bf42412feb220$var$gs);
}
function $e73bf42412feb220$var$pauseAudio(audioRef) {
    audioRef.pause();
}
function $e73bf42412feb220$var$playAudio(audioRef, isLoop = false) {
    audioRef.loop = isLoop;
    audioRef.play().catch((err)=>{
        console.log('Audio is not played ', err);
    });
}
function $e73bf42412feb220$var$setDOMEvents() {
    document.addEventListener('click', $e73bf42412feb220$var$handlePageInteractionClick);
    (0, $1168ec28d852752a$export$e40889aa17b92c99).forEach((el)=>el.addEventListener('click', $e73bf42412feb220$var$handleSelectionClick, false));
    (0, $1168ec28d852752a$export$e3883f6433e2084).addEventListener('click', $e73bf42412feb220$var$handleVSComputerClick, false);
    (0, $1168ec28d852752a$export$d452ebc8b446b4ac).addEventListener('click', $e73bf42412feb220$var$handleBackBtnClick, false);
    (0, $1168ec28d852752a$export$5a999186c9b43a0c).addEventListener('click', $e73bf42412feb220$var$handleAppBackBtnClick, false);
    (0, $1168ec28d852752a$export$beb2893780e62d5f).addEventListener('click', $e73bf42412feb220$var$handlePlayBtnClick, false);
    (0, $1168ec28d852752a$export$515ff3308e40a8b1).addEventListener('click', $e73bf42412feb220$var$handleBgPlayClick, false);
    // Onboarding: Personal Info (user name and avatar) screen
    (0, $1168ec28d852752a$export$50020fa44678e7c8).addEventListener('click', $e73bf42412feb220$var$handlePIBackBtnClick, false);
    (0, $1168ec28d852752a$export$f70504349406a407).addEventListener('click', $e73bf42412feb220$var$handlePINextBtnClick, false);
    (0, $1168ec28d852752a$export$d27b0802ab3cc977).addEventListener('keypress', $e73bf42412feb220$var$handleUserNameInteraction, false);
    (0, $1168ec28d852752a$export$d27b0802ab3cc977).addEventListener('change', $e73bf42412feb220$var$handleUserNameInteraction, false);
    (0, $1168ec28d852752a$export$c548831468cc80db).forEach((el)=>el.addEventListener('click', $e73bf42412feb220$var$handleUserAvatarClick, false));
}
/*** Initialise Main Gameplay ***/ function $e73bf42412feb220$var$hideUnusedColorTokens(colorsArr) {
    if (!colorsArr.length) return false;
    colorsArr.forEach((color)=>{
        (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token-${color}-1`).classList.add('d-none');
        (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token-${color}-2`).classList.add('d-none');
        (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token-${color}-3`).classList.add('d-none');
        (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token-${color}-4`).classList.add('d-none');
    });
}
function $e73bf42412feb220$var$updateGameTokenStyles(_selectedColor = '', _computerColor = '') {
    // Update game token positions for computer player
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_computerColor}-1`).classList.add('game-token-computer-1');
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_computerColor}-2`).classList.add('game-token-computer-2');
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_computerColor}-3`).classList.add('game-token-computer-3');
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_computerColor}-4`).classList.add('game-token-computer-4');
    // Update game token positions for user player
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_selectedColor}-1`).classList.add('game-token-user-1');
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_selectedColor}-2`).classList.add('game-token-user-2');
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_selectedColor}-3`).classList.add('game-token-user-3');
    (0, $1168ec28d852752a$export$d00693a4067fd789)(`.js-token.js-token-${_selectedColor}-4`).classList.add('game-token-user-4');
}
function $e73bf42412feb220$var$updateGameFortStyles(_selectedColor = '', _computerColor = '', unusedColorsArr = []) {
    const gameFortEl = (0, $1168ec28d852752a$export$d00693a4067fd789)('.js-game-fort');
    const borderTopColor = (0, $3940de47cfa7314f$export$67824cee260208a2)[_computerColor];
    const borderRightColor = (0, $3940de47cfa7314f$export$67824cee260208a2)[unusedColorsArr[1]];
    const borderBottomColor = (0, $3940de47cfa7314f$export$67824cee260208a2)[_selectedColor];
    const borderLeftColor = (0, $3940de47cfa7314f$export$67824cee260208a2)[unusedColorsArr[0]];
    const borderWidth = (0, $3940de47cfa7314f$export$39493557c84cfd54) ? '36px' : '75px';
    gameFortEl.style.setProperty('--game-fort-br-top', `${borderWidth} solid ${borderTopColor}`);
    gameFortEl.style.setProperty('--game-fort-br-right', `${borderWidth} solid ${borderRightColor}`);
    gameFortEl.style.setProperty('--game-fort-br-bottom', `${borderWidth} solid ${borderBottomColor}`);
    gameFortEl.style.setProperty('--game-fort-br-left', `${borderWidth} solid ${borderLeftColor}`);
}
function $e73bf42412feb220$var$updateGameHouseStyles(selector, newColor) {
    const el = (0, $1168ec28d852752a$export$d00693a4067fd789)(selector);
    const newColorClsName = `bgcolor-${newColor}`;
    const currentColorClsName = Array.from(el.classList).find((item)=>item.includes('bgcolor-'));
    el.classList.replace(currentColorClsName, newColorClsName);
    el.querySelectorAll('.token').forEach((node)=>{
        node.classList.replace(currentColorClsName, newColorClsName);
    });
}
function $e73bf42412feb220$var$updateGameTrackStyles(selector, newColor) {
    const el = (0, $1168ec28d852752a$export$d00693a4067fd789)(selector).querySelector('.track-dots');
    const newColorClsName = `bgcolor-${newColor}`;
    const currentColorClsName = Array.from(el.classList).find((item)=>item.includes('bgcolor-'));
    // Update game track colors for all players
    el.classList.replace(currentColorClsName, newColorClsName);
}
function $e73bf42412feb220$var$setupLayout(_selectedColor = '', _computerColor = '', unusedColorsArr = []) {
    // Update game house colors for computer player
    $e73bf42412feb220$var$updateGameHouseStyles('.game-house:nth-of-type(2)', _computerColor);
    // Update game house colors for user player
    $e73bf42412feb220$var$updateGameHouseStyles('.game-house:nth-of-type(3)', _selectedColor);
    // Update game house colors for unused top-left player
    $e73bf42412feb220$var$updateGameHouseStyles('.game-house:nth-of-type(1)', unusedColorsArr[0]);
    // Update game house colors for unused bottom-right player
    $e73bf42412feb220$var$updateGameHouseStyles('.game-house:nth-of-type(4)', unusedColorsArr[1]);
    // Update game track colors for computer player
    $e73bf42412feb220$var$updateGameTrackStyles('.game-track.game-track-top', _computerColor);
    // Update game track colors for user player
    $e73bf42412feb220$var$updateGameTrackStyles('.game-track.game-track-bottom', _selectedColor);
    // Update game track colors for unused top-left player
    $e73bf42412feb220$var$updateGameTrackStyles('.game-track.game-track-left', unusedColorsArr[0]);
    // Update game track colors for unused bottom-right player
    $e73bf42412feb220$var$updateGameTrackStyles('.game-track.game-track-right', unusedColorsArr[1]);
    // Update game token styles
    $e73bf42412feb220$var$updateGameTokenStyles(_selectedColor, _computerColor);
    // Update game fort styles
    $e73bf42412feb220$var$updateGameFortStyles(_selectedColor, _computerColor, unusedColorsArr);
}
function $e73bf42412feb220$var$setupUserAvatar(name, gender) {
    const { name: avatarName = '', url_48: url_48 = '', url_96: url_96 = '' } = $e73bf42412feb220$var$userAvatars.find((avatar)=>avatar.gender === gender);
    const srcset = `${url_48} 48w, ${url_96} 96w`;
    const imgAlt = `Avatar ${avatarName}`;
    (0, $1168ec28d852752a$export$b80866afb1e34266).setAttribute('srcset', srcset);
    (0, $1168ec28d852752a$export$b80866afb1e34266).setAttribute('src', url_96);
    (0, $1168ec28d852752a$export$b80866afb1e34266).setAttribute('alt', imgAlt);
    (0, $1168ec28d852752a$export$f041ceeccee253fc).textContent = name;
}
function $e73bf42412feb220$var$setupComputerAvatar(name, url_48, url_96) {
    const srcset = `${url_48} 48w, ${url_96} 96w`;
    const imgAlt = `Avatar ${name}`;
    (0, $1168ec28d852752a$export$3afb6fec7d6afc7c).setAttribute('srcset', srcset);
    (0, $1168ec28d852752a$export$3afb6fec7d6afc7c).setAttribute('src', url_96);
    (0, $1168ec28d852752a$export$3afb6fec7d6afc7c).setAttribute('alt', imgAlt);
    (0, $1168ec28d852752a$export$7302c976fb091b27).textContent = name;
}
function $e73bf42412feb220$var$getTokenById(el, obj) {
    return Object.values(obj).find((token)=>el.classList.contains(token.id) || el.parentNode.classList.contains(token.id));
}
function $e73bf42412feb220$var$setUserTokens() {
    const firstToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-user-1');
    const secondToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-user-2');
    const thirdToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-user-3');
    const fourthToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-user-4');
    $e73bf42412feb220$var$gs.userTokens = {
        first: {
            el: firstToken,
            id: 'game-token-user-1',
            // Current index on the ludo path
            index: 0,
            baseX: firstToken.getBoundingClientRect().left,
            baseY: firstToken.getBoundingClientRect().top,
            left: firstToken.getBoundingClientRect().left,
            top: firstToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        },
        second: {
            el: secondToken,
            id: 'game-token-user-2',
            index: 0,
            baseX: secondToken.getBoundingClientRect().left,
            baseY: secondToken.getBoundingClientRect().top,
            left: secondToken.getBoundingClientRect().left,
            top: secondToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        },
        third: {
            el: thirdToken,
            id: 'game-token-user-3',
            index: 0,
            baseX: thirdToken.getBoundingClientRect().left,
            baseY: thirdToken.getBoundingClientRect().top,
            left: thirdToken.getBoundingClientRect().left,
            top: thirdToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        },
        fourth: {
            el: fourthToken,
            id: 'game-token-user-4',
            index: 0,
            baseX: fourthToken.getBoundingClientRect().left,
            baseY: fourthToken.getBoundingClientRect().top,
            left: fourthToken.getBoundingClientRect().left,
            top: fourthToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        }
    };
    firstToken.addEventListener('click', $e73bf42412feb220$var$handleUserTokenClick, false);
    secondToken.addEventListener('click', $e73bf42412feb220$var$handleUserTokenClick, false);
    thirdToken.addEventListener('click', $e73bf42412feb220$var$handleUserTokenClick, false);
    fourthToken.addEventListener('click', $e73bf42412feb220$var$handleUserTokenClick, false);
}
function $e73bf42412feb220$var$setComputerTokens() {
    const firstToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-computer-1');
    const secondToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-computer-2');
    const thirdToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-computer-3');
    const fourthToken = (0, $1168ec28d852752a$export$d00693a4067fd789)('.game-token.game-token-computer-4');
    $e73bf42412feb220$var$gs.computerTokens = {
        first: {
            el: firstToken,
            id: 'game-token-computer-1',
            index: 0,
            baseX: firstToken.getBoundingClientRect().left,
            baseY: firstToken.getBoundingClientRect().top,
            left: firstToken.getBoundingClientRect().left,
            top: firstToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        },
        second: {
            el: secondToken,
            id: 'game-token-computer-2',
            index: 0,
            baseX: secondToken.getBoundingClientRect().left,
            baseY: secondToken.getBoundingClientRect().top,
            left: secondToken.getBoundingClientRect().left,
            top: secondToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        },
        third: {
            el: thirdToken,
            id: 'game-token-computer-3',
            index: 0,
            baseX: thirdToken.getBoundingClientRect().left,
            baseY: thirdToken.getBoundingClientRect().top,
            left: thirdToken.getBoundingClientRect().left,
            top: thirdToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        },
        fourth: {
            el: fourthToken,
            id: 'game-token-computer-4',
            index: 0,
            baseX: fourthToken.getBoundingClientRect().left,
            baseY: fourthToken.getBoundingClientRect().top,
            left: fourthToken.getBoundingClientRect().left,
            top: fourthToken.getBoundingClientRect().top,
            isAtHome: true,
            isOpen: false,
            isSafe: false,
            isAtFort: false
        }
    };
}
function $e73bf42412feb220$var$setupUserDice() {
    // Create the user dice instance with selectors
    $e73bf42412feb220$var$_userDice = new (0, $360df857f4c2c54a$export$2e2bcd8739ae039)('User Dice', 'dice1', 'dice2', 'dice-roll-btn', 'dice-roll-audio', (0, $3940de47cfa7314f$export$159f0a52d65c72e1));
    $e73bf42412feb220$var$_userDice.buildDice($e73bf42412feb220$var$_userDice.dice1);
    $e73bf42412feb220$var$_userDice.buildDice($e73bf42412feb220$var$_userDice.dice2);
    $e73bf42412feb220$var$_userDice.setDiceValue($e73bf42412feb220$var$_userDice.dice1);
    $e73bf42412feb220$var$_userDice.setDiceValue($e73bf42412feb220$var$_userDice.dice2);
    $e73bf42412feb220$var$_userDice.attachRollBtn();
    // Make user player active as it will start the game
    (0, $1168ec28d852752a$export$5b5a59babade6caa).disabled = false;
    // Show arrow indicator on user "dice roll" button
    $e73bf42412feb220$var$removeClassFromEl((0, $1168ec28d852752a$export$e910906a19a619c7), 'd-none');
    // Hide arrow indicator on both user dice
    $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$5c2a73161bb2780a), 'd-none');
    $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$49356edcc2c3205c), 'd-none');
    // Set User turn as "active" and show pulse animation
    $e73bf42412feb220$var$setUserActiveTurn();
    $e73bf42412feb220$var$showPulseAnim((0, $1168ec28d852752a$export$70fcad33caef45a9));
}
function $e73bf42412feb220$var$setupComputerDice() {
    // Create the computer dice instance with selectors
    $e73bf42412feb220$var$_computerDice = new (0, $360df857f4c2c54a$export$2e2bcd8739ae039)('Computer Dice', 'dice3', 'dice4', 'dice-roll-btn-2', 'dice-roll-audio-2', (0, $3940de47cfa7314f$export$aab74dc964543f9e));
    $e73bf42412feb220$var$_computerDice.buildDice($e73bf42412feb220$var$_computerDice.dice1);
    $e73bf42412feb220$var$_computerDice.buildDice($e73bf42412feb220$var$_computerDice.dice2);
    $e73bf42412feb220$var$_computerDice.setDiceValue($e73bf42412feb220$var$_computerDice.dice1);
    $e73bf42412feb220$var$_computerDice.setDiceValue($e73bf42412feb220$var$_computerDice.dice2);
    $e73bf42412feb220$var$_computerDice.attachRollBtn();
}
function $e73bf42412feb220$var$setUserActiveTurn() {
    $e73bf42412feb220$var$gs.activeTurn = 'user';
}
function $e73bf42412feb220$var$setActiveTurnComputer() {
    $e73bf42412feb220$var$gs.activeTurn = 'computer';
}
function $e73bf42412feb220$var$setupCustomEvents() {
    // Detach custom events first to prevent redundant calls
    document.removeEventListener((0, $3940de47cfa7314f$export$159f0a52d65c72e1), $e73bf42412feb220$var$handleUserDiceRoll, false);
    document.removeEventListener((0, $3940de47cfa7314f$export$aab74dc964543f9e), $e73bf42412feb220$var$handleComputerDiceRoll, false);
    document.removeEventListener((0, $3940de47cfa7314f$export$e3962ae0d04ddee0), $e73bf42412feb220$var$handleUserTurnActive, false);
    document.removeEventListener((0, $3940de47cfa7314f$export$4961220119009338), $e73bf42412feb220$var$handleComputerTurnActive, false);
    // Attach user and computer custom events
    document.addEventListener((0, $3940de47cfa7314f$export$159f0a52d65c72e1), $e73bf42412feb220$var$handleUserDiceRoll, false);
    document.addEventListener((0, $3940de47cfa7314f$export$aab74dc964543f9e), $e73bf42412feb220$var$handleComputerDiceRoll, false);
    document.addEventListener((0, $3940de47cfa7314f$export$e3962ae0d04ddee0), $e73bf42412feb220$var$handleUserTurnActive, false);
    document.addEventListener((0, $3940de47cfa7314f$export$4961220119009338), $e73bf42412feb220$var$handleComputerTurnActive, false);
}
function $e73bf42412feb220$var$dispatchUserTurnEvent() {
    // Dispatch custom event to set active turn for user
    setTimeout(()=>{
        document.dispatchEvent(new CustomEvent((0, $3940de47cfa7314f$export$e3962ae0d04ddee0), {
            detail: {
                activeTurn: 'user'
            }
        }));
    }, 500);
}
function $e73bf42412feb220$var$dispatchComputerTurnEvent() {
    // Dispatch custom event to set active turn for computer
    setTimeout(()=>{
        document.dispatchEvent(new CustomEvent((0, $3940de47cfa7314f$export$4961220119009338), {
            detail: {
                activeTurn: 'computer'
            }
        }));
    }, 500);
}
/**
 * Shows the "GAME START" animation once.
 * Call this after onboarding is complete.
 */ function $e73bf42412feb220$var$showGameStartAnimation() {
    const overlay = document.getElementById('game-start-overlay');
    // Show overlay
    overlay.classList.remove('hidden');
    // Restart animation if called multiple times
    overlay.classList.remove('show');
    overlay.offsetWidth; // Force reflow
    overlay.classList.add('show');
    // Hide overlay after animation completes
    const DURATION = 2800; // Must match CSS animation duration
    setTimeout(()=>{
        overlay.classList.remove('show');
        overlay.classList.add('hidden');
    }, DURATION);
}
function $e73bf42412feb220$var$getEligibleTokens(dice, tokenObj) {
    const { tokenOpenArr: tokenOpenArr } = $e73bf42412feb220$var$gs;
    const canOpenToken = tokenOpenArr.includes(dice);
    return Object.values(tokenObj).filter((token)=>{
        const isTokenAtHome = token.index === 0 && token.isAtHome && !token.isOpen && !token.isSafe && !token.isAtFort;
        const isTokenOnBoard = token.index >= 0 && !token.isAtHome && token.isOpen && !token.isAtFort;
        if (canOpenToken) // Tokens still at home and eligible to be opened
        return isTokenAtHome || isTokenOnBoard;
        // Tokens already on the board and eligible to move
        return isTokenOnBoard;
    });
}
/** User dice roll custom event handler **/ function $e73bf42412feb220$var$handleUserDiceRoll(e) {
    console.log('User dice rolled: ', e.detail);
    let { dice1: dice1, dice2: dice2 } = e.detail;
    if (!dice1 || !dice2) {
        console.log('Invalid dice values rolled.');
        return;
    }
    dice1 = Number(dice1);
    dice2 = Number(dice2);
    $e73bf42412feb220$var$gs.userDice.first = dice1;
    $e73bf42412feb220$var$gs.userDice.second = dice2;
    // Disable user "dice roll" button
    (0, $1168ec28d852752a$export$5b5a59babade6caa).disabled = true;
    // Hide arrow indicator on user "dice roll" button
    $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$e910906a19a619c7), 'd-none');
    if ($e73bf42412feb220$var$getEligibleTokens(dice1, $e73bf42412feb220$var$gs.userTokens).length) {
        // Set Eligible tokens for Dice1
        $e73bf42412feb220$var$gs.tokenEligibleArr = $e73bf42412feb220$var$getEligibleTokens(dice1, $e73bf42412feb220$var$gs.userTokens);
        // Set eligible tokens active
        $e73bf42412feb220$var$gs.tokenEligibleArr.forEach((token)=>{
            token.el.classList.add('token-eligible');
        });
        $e73bf42412feb220$var$gs.playerTurns = 2;
        // Show pulse animation on first user dice
        $e73bf42412feb220$var$showPulseAnim((0, $1168ec28d852752a$export$747ca200babe9292));
        // Show arrow indicator on "first" user dice
        $e73bf42412feb220$var$removeClassFromEl((0, $1168ec28d852752a$export$5c2a73161bb2780a), 'd-none');
        // Hide arrow indicator on "second" user dice
        $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$49356edcc2c3205c), 'd-none');
        console.log('Eligible tokens for dice1: ', $e73bf42412feb220$var$gs.tokenEligibleArr);
    } else if ($e73bf42412feb220$var$getEligibleTokens(dice2, $e73bf42412feb220$var$gs.userTokens).length) {
        // Set Eligible tokens for Dice2
        $e73bf42412feb220$var$gs.tokenEligibleArr = $e73bf42412feb220$var$getEligibleTokens(dice2, $e73bf42412feb220$var$gs.userTokens);
        // Set eligible tokens active
        $e73bf42412feb220$var$gs.tokenEligibleArr.forEach((token)=>{
            token.el.classList.add('token-eligible');
        });
        $e73bf42412feb220$var$gs.playerTurns = 1;
        $e73bf42412feb220$var$gs.userDice.first = null;
        // Hide pulse animation on first user dice
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$747ca200babe9292));
        // Show pulse animation on second user dice
        $e73bf42412feb220$var$showPulseAnim((0, $1168ec28d852752a$export$a37d94e9af1a9115));
        // Hide arrow indicator on "first" user dice
        $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$5c2a73161bb2780a), 'd-none');
        // Show arrow indicator on "second" user dice
        $e73bf42412feb220$var$removeClassFromEl((0, $1168ec28d852752a$export$49356edcc2c3205c), 'd-none');
        console.log('Eligible tokens for dice2: ', $e73bf42412feb220$var$gs.tokenEligibleArr);
    } else {
        $e73bf42412feb220$var$gs.playerTurns = 0;
        $e73bf42412feb220$var$gs.userDice.first = null;
        $e73bf42412feb220$var$gs.userDice.second = null;
        console.log('No eligible tokens for the user: ', $e73bf42412feb220$var$gs.tokenEligibleArr);
        // Hide pulse animations for first and second user dice
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$747ca200babe9292));
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$a37d94e9af1a9115));
        // Hide arrow indicators on "first" and "second" user dice
        $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$5c2a73161bb2780a), 'd-none');
        $e73bf42412feb220$var$addClassToEl((0, $1168ec28d852752a$export$49356edcc2c3205c), 'd-none');
        $e73bf42412feb220$var$dispatchComputerTurnEvent();
    }
    console.log('current game state: ', $e73bf42412feb220$var$gs);
}
function $e73bf42412feb220$var$moveComputerToken(dice, tokenObj) {
    const isTokenEligibleToOpen = $e73bf42412feb220$var$gs.tokenOpenArr.indexOf(dice) > -1 && tokenObj.el && tokenObj.index === 0 && tokenObj.isAtHome && !tokenObj.isOpen && !tokenObj.isSafe && !tokenObj.isAtFort;
    const pathIndex = isTokenEligibleToOpen ? 0 : tokenObj.index + dice;
    const currentState = (0, $3940de47cfa7314f$export$39493557c84cfd54) ? (0, $3940de47cfa7314f$export$329cf0911c3b69bf)[pathIndex] : (0, $3940de47cfa7314f$export$a603f1620086eaac)[pathIndex];
    if (isTokenEligibleToOpen) {
        tokenObj.isOpen = true;
        tokenObj.isAtHome = false;
    }
    // Update user index to new path location
    tokenObj.index = pathIndex;
    // Move the user token to new path location
    tokenObj.el.style.left = currentState.left;
    tokenObj.el.style.top = currentState.top;
    // Decrement player turn by one
    $e73bf42412feb220$var$gs.playerTurns -= 1;
    // Reset eligible token className from all tokens
    $e73bf42412feb220$var$gs.tokenEligibleArr.forEach((token)=>{
        token.el.classList.remove('token-eligible');
    });
}
function $e73bf42412feb220$var$playComputerTurn(diceNum, dice, tokenCollection, diceElOne, diceElTwo) {
    return new Promise((resolve, reject)=>{
        const eligibleTokens = $e73bf42412feb220$var$getEligibleTokens(dice, tokenCollection);
        if (!eligibleTokens.length) {
            console.log(`No eligible tokens for the computer dice: ${dice}`, eligibleTokens);
            return resolve(true);
        }
        // Set Eligible tokens for Dice
        $e73bf42412feb220$var$gs.tokenEligibleArr = eligibleTokens;
        // Set eligible tokens active
        $e73bf42412feb220$var$gs.tokenEligibleArr.forEach((token)=>{
            token.el.classList.add('token-eligible');
        });
        console.log(`Eligible tokens for computer dice: ${dice}: `, eligibleTokens);
        const tokenObj = eligibleTokens[0];
        $e73bf42412feb220$var$moveComputerToken(dice, tokenObj);
        if (diceNum === 1) {
            console.log('Computer token selected for dice 1: ', tokenObj);
            // Show pulse animation on first user dice
            $e73bf42412feb220$var$showPulseAnim(diceElOne);
        } else if (diceNum === 2) {
            // Show pulse animation on first user dice
            $e73bf42412feb220$var$hidePulseAnim(diceElOne);
            $e73bf42412feb220$var$showPulseAnim(diceElTwo);
        }
        setTimeout(()=>{
            console.log(`[ComputerTurn]: Played dice ${diceNum} turn: `, dice);
            resolve(true);
        }, 500);
    });
}
/** Computer dice roll custom event handler **/ function $e73bf42412feb220$var$handleComputerDiceRoll(e) {
    console.log('Computer dice rolled: ', e.detail);
    let { dice1: dice1, dice2: dice2 } = e.detail;
    if (!dice1 || !dice2) {
        console.log('Computer Dice: Invalid dice values rolled.');
        return;
    }
    dice1 = Number(dice1);
    dice2 = Number(dice2);
    $e73bf42412feb220$var$gs.computerDice.first = dice1;
    $e73bf42412feb220$var$gs.computerDice.second = dice2;
    $e73bf42412feb220$var$gs.playerTurns = 2;
    $e73bf42412feb220$var$playComputerTurn(1, dice1, $e73bf42412feb220$var$gs.computerTokens, (0, $1168ec28d852752a$export$e1124a4189ecaf6e), (0, $1168ec28d852752a$export$ae90a12dc449330f)).then(()=>$e73bf42412feb220$var$playComputerTurn(2, dice2, $e73bf42412feb220$var$gs.computerTokens, (0, $1168ec28d852752a$export$e1124a4189ecaf6e), (0, $1168ec28d852752a$export$ae90a12dc449330f))).then(()=>{
        $e73bf42412feb220$var$gs.computerDice.first = null;
        $e73bf42412feb220$var$gs.computerDice.second = null;
        $e73bf42412feb220$var$gs.tokenEligibleArr = [];
        // Hide pulse animations for first and second computer dice
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$e1124a4189ecaf6e));
        $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$ae90a12dc449330f));
        $e73bf42412feb220$var$dispatchUserTurnEvent();
        console.log('[ComputerDiceRoll]: Played both turns');
    }).catch((err)=>console.log('Error in playing computer turn: ', err));
}
/** User turn active custom event handler **/ function $e73bf42412feb220$var$handleUserTurnActive(e) {
    console.log('User turn is active: ', e.detail);
    // Set user avatar as active
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$5e9b7b9ab82179a7));
    $e73bf42412feb220$var$showPulseAnim((0, $1168ec28d852752a$export$70fcad33caef45a9));
    $e73bf42412feb220$var$setUserActiveTurn();
    (0, $1168ec28d852752a$export$5b5a59babade6caa).disabled = false;
    // Show arrow indicator on user "dice roll" button
    $e73bf42412feb220$var$removeClassFromEl((0, $1168ec28d852752a$export$e910906a19a619c7), 'd-none');
}
/** Computer turn active custom event handler **/ function $e73bf42412feb220$var$handleComputerTurnActive(e) {
    console.log('Computer turn is active: ', e.detail);
    // Set computer avatar as active
    $e73bf42412feb220$var$hidePulseAnim((0, $1168ec28d852752a$export$70fcad33caef45a9));
    $e73bf42412feb220$var$showPulseAnim((0, $1168ec28d852752a$export$5e9b7b9ab82179a7));
    $e73bf42412feb220$var$setActiveTurnComputer();
    (0, $1168ec28d852752a$export$a7e61876d5641618).click();
}
function $e73bf42412feb220$var$initGamePlay() {
    const activeColorsArr = $e73bf42412feb220$var$getActiveColors($e73bf42412feb220$var$_selectedColor);
    const unusedColorsArr = (0, $3940de47cfa7314f$export$c07180e0eb2fbe84).filter((item)=>activeColorsArr.indexOf(item) === -1);
    const { name: computerAvatar = '', url_48: computerAvatarURL48 = '', url_96: computerAvatarURL96 = '' } = $e73bf42412feb220$var$computerAvatars[Math.floor(Math.random() * 5)];
    $e73bf42412feb220$var$hideUnusedColorTokens(unusedColorsArr);
    $e73bf42412feb220$var$gs.hasGameStarted = true;
    $e73bf42412feb220$var$_computerColor = activeColorsArr[1];
    $e73bf42412feb220$var$setupLayout($e73bf42412feb220$var$_selectedColor, $e73bf42412feb220$var$_computerColor, unusedColorsArr);
    $e73bf42412feb220$var$setUserInfoInStorage((0, $3940de47cfa7314f$export$c7cf9db58a387a28), $e73bf42412feb220$var$_userName, $e73bf42412feb220$var$_userAvatar, $e73bf42412feb220$var$_userAvatarURL);
    $e73bf42412feb220$var$setupUserAvatar($e73bf42412feb220$var$_userName, $e73bf42412feb220$var$_userAvatar);
    $e73bf42412feb220$var$setupComputerAvatar(computerAvatar, computerAvatarURL48, computerAvatarURL96);
    // Hide Onboarding screen and show main App screen
    (0, $1168ec28d852752a$export$3ce7eb6bf6aeba9b).classList.add('d-none');
    (0, $1168ec28d852752a$export$1f183a908848c907).classList.remove('d-none');
    // Show Game start animation
    $e73bf42412feb220$var$showGameStartAnimation();
    $e73bf42412feb220$var$gameStartAudio.currentTime = 0;
    // Play "Game Start" audio
    $e73bf42412feb220$var$playAudio($e73bf42412feb220$var$gameStartAudio);
    // Setup User & Computer dice UI
    $e73bf42412feb220$var$setupUserDice();
    $e73bf42412feb220$var$setupComputerDice();
    // Cache user and computer token details (DOM refs and states)
    $e73bf42412feb220$var$setUserTokens();
    $e73bf42412feb220$var$setComputerTokens();
    $e73bf42412feb220$var$setupCustomEvents();
    // Show data logs for testing/debugging
    console.log('user color: ', $e73bf42412feb220$var$_selectedColor);
    console.log('computer color: ', $e73bf42412feb220$var$_computerColor);
    console.log('unused colors: ', unusedColorsArr);
    console.log('username: ', $e73bf42412feb220$var$_userName, ', _userAvatar: ', $e73bf42412feb220$var$_userAvatar);
    console.log('computer Avatar: ', computerAvatar, ', computer avatar URL: ', computerAvatarURL96);
    console.log('user tokens: ', $e73bf42412feb220$var$gs.userTokens, ', computer tokens: ', $e73bf42412feb220$var$gs.computerTokens);
}
console.log('Ludo game JS loaded.');
$e73bf42412feb220$var$setDOMEvents();
$e73bf42412feb220$var$populatePIScreen();


//# sourceMappingURL=index.e8664e5d.js.map
